// Email functions

/**
 * Method that opens the system's email management tool to snd an email to the given advisor. 
 * @param {string} advisorEmail - Advisor's 
 */
export const contactAdvisor = (advisorEmail) =>
{
    window.open(`mailto:${advisorEmail}`)
}